export default __webpack_public_path__ + "static/media/HOmetutor.551fe41f.png";